export const WhiteHEX = '#fff';

export const GrayHEX = '#a6a6a6';

export const BlackHEX = '#000';

export const FirstMobileColor = '#00CCC8';

export const SecondMobileColor = '#2175BB';

export const ThirdMobileColor = '#FFF';

export const WhiteRGBA = {
    r: '255',
    g: '255',
    b: '255',
    a: '1'
};

export const BlackRGBA = {
    r: '0',
    g: '0',
    b: '0',
    a: '1'
};

export const rgbaToHex = rgba => {
    let r = parseInt(rgba.r, 16),
        g = parseInt(rgba.g, 16),
        b = parseInt(rgba.b, 16);

    return ('#' + r.toString(16) + g.toString(16) + b.toString(16));
};

export const hexToRGB = hex => {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: 1
        } : null;
};


// WEBPACK FOOTER //
// ./src/customModules/Common/colors/colors.js